<label
  class="eva-switch"
  [class.eva-switch--checked]="_checked"
  [class.eva-switch--disabled]="isDisabled"
  [class.eva-switch--loading]="loading"
  [class.eva-switch--focused]="isFocused"
  [class.eva-switch--small]="size === 'small'"
  [class.eva-switch--medium]="size === 'medium'"
  [class.eva-switch--large]="size === 'large'"
  [class.eva-switch--label-before]="labelPosition === 'before'"
  [class.eva-switch--has-description]="description"
>
  <!-- Label content (before position) -->
  <span
    *ngIf="(label || description) && labelPosition === 'before'"
    class="eva-switch__content eva-switch__content--before"
  >
    <span *ngIf="label" class="eva-switch__label">{{ label }}</span>
    <span *ngIf="description" class="eva-switch__description">{{ description }}</span>
  </span>

  <!-- Hidden native checkbox for accessibility -->
  <input
    type="checkbox"
    [id]="inputId"
    [checked]="_checked"
    [disabled]="isDisabled"
    class="eva-switch__native"
    role="switch"
    [attr.aria-checked]="_checked"
    (change)="toggle()"
    (focus)="handleFocus()"
    (blur)="handleBlur()"
    (keydown)="handleKeydown($event)"
  />

  <!-- Switch track -->
  <span class="eva-switch__track">
    <!-- Thumb/knob -->
    <span class="eva-switch__thumb">
      <!-- Loading spinner -->
      <svg *ngIf="loading" class="eva-switch__spinner" viewBox="0 0 16 16" fill="none">
        <circle
          cx="8"
          cy="8"
          r="6"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-dasharray="28"
          stroke-dashoffset="8"
        />
      </svg>
    </span>
  </span>

  <!-- State label (ON/OFF) -->
  <span *ngIf="currentStateLabel" class="eva-switch__state-label">
    {{ currentStateLabel }}
  </span>

  <!-- Label content (after position) -->
  <span
    *ngIf="(label || description) && labelPosition === 'after'"
    class="eva-switch__content eva-switch__content--after"
  >
    <span *ngIf="label" class="eva-switch__label">{{ label }}</span>
    <span *ngIf="description" class="eva-switch__description">{{ description }}</span>
  </span>
</label>
